// Translation file for TehetsegesHallgatok component
// Contains all UI text in Hungarian and English

export const TEHETSEGESHALLGATOK_TRANSLATIONS = {
    hu: {
        pageTitle: "3. Tehetséges, kiemelkedő hallgatói teljesítmények",
        
        section1: {
            title: "3.1. Hallgatói önkormányzatban végzett tevékenység",
            source: "Forrás: ",
            subtitle: "A szak hallgatóinak részvétele a HÖK munkájában"
        },
        
        section2: {
            title: "3.2. Szakkollégiumi tevékenység",
            source: "Forrás: ",
            subtitle: "A szak hallgatóinak részvétele szakkollégiumban"
        },
        
        section3: {
            title: "3.3. Hallgatói csapatokban való tevékenység",
            source: "Forrás: ",
            subtitle: "A szak hallgatóinak részvétele hallgatói csapatokban"
        },

        section4: {
            title: "3.4. Sporttevékenység",
            source: "Forrás: ",
            subtitle1: "A szak hallgatóinak sporttevékenységben való részvétele",
            subtitle2: "Kiemelkedő sporteredmények (ha van)"
        },

        section5: {
            title: "3.5. Kiemelkedő tanulmányi/szakmai munkáért ösztöndíjban részesülők száma",
            source: "Forrás: ",
            subtitle1: "Ösztöndíjas hallgatók számának értékelése",
            subtitle2: "Ösztöndíjas hallgatók szakon belüli aránya"
        },
        
        buttons: {
            previous: "Előző szakasz",
            next: "Következő szakasz",
            save: "Mentés",
            finalize: "Véglegesítés",
            unfinalize: "Véglegesítés visszavonása"
        },
        
        alerts: {
            requiredFields: "Minden szöveges mezőt ki kell tölteni!"
        },
        
        modal: {
            imageAlt: "Nagyított kép",
            closeButton: "Bezárás"
        },
        
        sidebar: [
            "Szak alapadatok",
            "A képzés",
            "A szak mintatanterve",
            "Tehetséges, kiemelkedő hallgatói teljesítmények",
            "Idegen nyelvi követelmények",
            "Kötelező szakmai gyakorlat",
            "Mintatanterv fejlesztések, módosítások",
            "Fejlesztési javaslatok",
            "Oktatás",
            "A szak hallgatóira vonatkozó adatok",
            "Versenytárs elemzés",
            "Meghívott előadók és óraadók",
            "Oktatók értékelése",
            "A képzés tanulmányi körülményei",
            "A szak kommunikációja",
            "Fejlesztési javaslatok megvalósítása és értékelése",
            "Szakjelentés lezárása"
        ]
    },
    
    en: {
        pageTitle: "3. Outstanding and High-Achieving Student Performance",
        
        section1: {
            title: "3.1. Student Union Activities",
            source: "Source: ",
            subtitle: "Participation of programme students in Student Union activities"
        },
        
        section2: {
            title: "3.2. Activities in Talent Management Programmes",
            source: "Source: ",
            subtitle: "Participation of programme students in a Talent Management Programme"
        },
        
        section3: {
            title: "3.3. Participation in Student Teams",
            source: "Source: ",
            subtitle: "Participation of students of the programme in student teams"
        },

        section4: {
            title: "3.4. Sports Activities",
            source: "Source: ",
            subtitle1: "Participation of students of the programme in sports activities",
            subtitle2: "Outstanding sports achievements (if applicable)"
        },

        section5: {
            title: "3.5. Number of Students Awarded Scholarships for Outstanding Academic and/or Professional Performance",
            source: "Source: ",
            subtitle1: "Assessment of the number of scholarship recipients",
            subtitle2: "Proportion of scholarship recipients within the programme"
        },
        
        buttons: {
            previous: "Previous Section",
            next: "Next Section",
            save: "Save",
            finalize: "Finalize",
            unfinalize: "Withdraw Finalization"
        },
        
        alerts: {
            requiredFields: "All text fields must be filled!"
        },
        
        modal: {
            imageAlt: "Enlarged image",
            closeButton: "Close"
        },
        
        sidebar: [
            "Programme Basic Data",
            "The Programme",
            "Programme Curriculum",
            "Talented Students and Outstanding Student Performance",
            "Foreign Language Requirements",
            "Compulsory Professional Practice",
            "Curriculum Developments and Modifications",
            "Development Recommendations",
            "Teaching",
            "Data related to the major",
            "Competitor Analysis",
            "Guest Lecturers and Part-time Teachers",
            "Assessment of Teachers",
            "Study Conditions",
            "Programme Communication",
            "Implementation and Evaluation of Development Recommendations",
            "Finalisation of Programme Report"
        ]
    }
};